import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Game, Category } from '../types';
import './CategoryGames.css';
import { allGames, categories } from '../data/staticData';

const CategoryGames: React.FC = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const [games, setGames] = useState<Game[]>([]);
  const [category, setCategory] = useState<Category | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch category details
        // const categoryResponse = await fetch(`/api/categories/${categoryId}`);
        // if (!categoryResponse.ok) {
        //   throw new Error(`HTTP error! status: ${categoryResponse.status}`);
        // }
        // const categoryData = await categoryResponse.json();
        const categoryData = categories.filter(x => x.id == parseInt(categoryId|| "0"))[0];
        setCategory(categoryData);

        // Fetch all games for this category
        // const gamesResponse = await fetch(`/api/categories/${categoryId}/games`);
        // if (!gamesResponse.ok) {
        //   throw new Error(`HTTP error! status: ${gamesResponse.status}`);
        // }
        // const gamesData = await gamesResponse.json();

        const gamesData = allGames.filter(x => x.category_id == categoryId)
        setGames(gamesData);
        setError(null);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error instanceof Error ? error.message : 'Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [categoryId]);

  if (loading) {
    return <div className="loading">Loading games...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  if (!category) {
    return <div className="error">Category not found</div>;
  }

  return (
    <div className="category-games">
      <div className="category-header">
        <h1 className="category-title">{category.name}</h1>
        <Link to="/" className="back-link">← Back to Home</Link>
      </div>
      
      <div className="games-grid">
        {games.map(game => (
          <Link to={`/game/${game.urlkey}`} key={game.id} className="game-card">
            <div className="thumbnail-container">
              <img 
                src={game.thumbnailUrl} 
                alt={game.title} 
                className="game-thumbnail"
              />
              <div className="game-title">{game.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoryGames; 